<form class="popupForm" style="min-height: 300px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title class="flex-row-center flex-justify-space-between">
      <ng-container>{{'game_result' | GetLabelPipe}}</ng-container>
      <div class="flex-row-center"
           [class.flex-justify-space-between]="allowEditMode"
           [class.flex-justify-end]="!allowEditMode"
           style="width: 75px;">
        <button mat-icon-button mat-dialog-close alt="close" title="close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 250px;">
      <div class="event-view-content">

        <div class="split-items-container">
          <div class="profile-left flex-column-center">
            <div class="event-user-icon event-user-icon-split bigger-badge-split-popup"
                 matBadge="{{profileLeft['cup_position']}}" matBadgeColor="accent">
              <img src="{{profileLeft['picture_src_preview']}}"
                   alt="{{profileLeft['shipping_name']}}" title="{{profileLeft['shipping_name']}}"
                   style="{{ profileLeft['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
              />
              <div *ngIf="false" class="edit-game-profile-icon flex-row-center flex-justify-center">
                <mat-icon>edit</mat-icon>
              </div>
            </div>
            <div class="user-name user-name-split user-name-as-link">
              {{profileLeft['shipping_name']}}
            </div>
            <div class="flex-row-center points-label" [class.red-points-label]="(profileLeft['rank_add'] < 0)"
                 *ngIf="this.gamePayload['status']==='confirmed' && profileLeft['rank_add']">
              <mat-icon>emoji_events</mat-icon><span>&nbsp;{{(profileLeft['rank_add'] > 0) ? '+'+profileLeft['rank_add'] : profileLeft['rank_add']}}</span>
            </div>
            <div class="flex-row-center points-label" *ngIf="this.gamePayload['status']==='confirmed' && profileLeft['points_add']">
              <mat-icon>savings</mat-icon><span>&nbsp;+{{profileLeft['points_add']}}</span>
            </div>
          </div>

          <div class="event-score flex-column-center">
            <div *ngIf="gamePayload['status']==='confirmed'">{{gamePayload['score']}}</div>
            <div *ngIf="['canceled','walkover'].includes(gamePayload['status'])">❌</div>
            <div *ngIf="['proposal','pending','score_confirmation'].includes(gamePayload['status'])">⏳</div>
          </div>

          <div class="profile-right flex-column-center">
            <div class="event-user-icon event-user-icon-split bigger-badge-split-popup"
                 matBadge="{{profileRight['cup_position']}}" matBadgeColor="accent">
              <img src="{{profileRight['picture_src_preview']}}"
                   alt="{{profileRight['shipping_name']}}" title="{{profileRight['shipping_name']}}"
                   style="{{ profileRight['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
              />
              <div *ngIf="false" class="edit-game-profile-icon flex-row-center flex-justify-center">
                <mat-icon>edit</mat-icon>
              </div>
            </div>
            <div class="user-name user-name-split user-name-as-link">
              {{profileRight['shipping_name']}}
            </div>
            <div class="flex-row-center points-label" [class.red-points-label]="(profileRight['rank_add'] < 0)"
                 *ngIf="this.gamePayload['status']==='confirmed' && profileRight['rank_add']">
              <mat-icon>emoji_events</mat-icon><span>&nbsp;{{(profileRight['rank_add'] > 0) ? '+'+profileRight['rank_add'] : profileRight['rank_add']}}</span>
            </div>
            <div class="flex-row-center points-label" *ngIf="this.gamePayload['status']==='confirmed' && profileRight['points_add']">
              <mat-icon>savings</mat-icon><span>&nbsp;+{{profileRight['points_add']}}</span>
            </div>
          </div>
        </div>

        <div *ngIf="errMsg" style="margin: 30px 0px 0px 0px;" fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="10px">
          <div style="border: 1px solid red; border-radius: 4px; padding: 10px;">
            ⚠️ {{errMsg}}
          </div>
        </div>

        <div style="margin: 20px 0px">
          <form [formGroup]="componentForm"
                *ngIf="mode === 'edit_game'" class="event-description flex-row-center flex-justify-center">
            <mat-form-field appearance="outline" color="accent" style="width: 20%">
              <mat-label>Score</mat-label>
              <select matNativeControl formControlName="scoreLeft">
                <option *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];"
                        value="{{i}}">{{i}}</option>
              </select>
            </mat-form-field>
            <div style="width: 80px; text-align: center">:</div>
            <mat-form-field appearance="outline" color="accent" style="width: 20%">
              <mat-label>Score</mat-label>
              <select matNativeControl  formControlName="scoreRight">
                <option *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];"
                        value="{{i}}">{{i}}</option>
              </select>
            </mat-form-field>
          </form>
        </div>

        <div *ngIf="mode !== 'edit_game'" class="event-description flex-column-center">
          <ng-container *ngIf="['game_proposal','tournament_game_proposal'].includes(this.gamePayload['type'])">
            <div class="event-description-title">{{'game_status_'+gamePayload['status'] | GetLabelPipe}}</div>
          </ng-container>
          <div *ngIf="gamePayload['class_name'] && gamePayload['class_id']"
               class="event-description-line">
            {{'event_group' | GetLabelPipe}}: <a target="_blank" href="/{{application.appLang}}/squash/classview/{{gamePayload['class_id']}}">{{gamePayload['class_name']}}</a>
          </div>
        </div>

      </div>
    </mat-dialog-content>
    <div class="is-relative" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'close' | GetLabelPipe}}
      </button>
      <button *ngIf="mode == 'edit_game'" color="accent"
              (click) = "saveGame()"
              [disabled]="!profileLeft['id'] || !profileRight['id']"
              mat-raised-button class="cancel widerButton font16" >
        {{'cup_action_send_confirmation' | GetLabelPipe}}
      </button>
      <button *ngIf="allowEventDelete" color="warn"
              [disabled]="mode == 'loading'"
              mat-raised-button class="cancel widerButton font16" >
        {{'delete' | GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
